import { buildMakeUseAxios } from "@api";
import type { ITemplate } from "@bbj-types/templates";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}`);

export const useGetOneTemplate = () => {
  const [state, execute, cancel] = axios<ITemplate>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (value: string, byName: boolean) => {
      return execute({
        url: `/templates/${value}`,
        params: byName ? { byName } : undefined,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export interface IGetTemplateBody {
  data: (ITemplate & { _id: string })[];
}
[];

export const useGetTemplates = () => {
  const [state, execute, cancel] = axios<IGetTemplateBody, any, unknown>(
    {
      url: "/templates",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters) => {
      return execute({
        url: `/templates`,
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useDeleteTemplate = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/templates",
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (templateId) => {
      return execute({
        url: `/templates/${templateId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useCreateTemplate = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/templates",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data) => {
      return execute({
        url: "/templates",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useUpdateTemplate = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/templates",
      method: "PUT",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data) => {
      return execute({
        url: `/templates/${data._id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
